import { Card, withStyles } from '@material-ui/core';

export default withStyles(() => ({
  root: {
    backgroundColor: 'white',
    borderRadius: 16,
    boxShadow: 'rgba(145, 158, 171, 0.24) 0px 0px 2px 0px, rgba(145, 158, 171, 0.24) 0px 16px 32px -4px',
    display: 'flex',
    flexDirection: 'column',
    padding: 24,
  },
}))(Card);
